import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetLocationsResult } from './get-locations.result';

export async function getLocations(): Promise<GetLocationsResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetLocationsResult[]>(`/location-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
